import { Injectable } from '@angular/core';

import { select, Store } from '@ngrx/store';

import { DocumentsPartialState } from './documents.reducer';
import { DocumentForm } from './documents.models';
import { documentsQuery } from './documents.selectors';
import {
  LoadOwnerDocuments,
  SaveDocumentInformation,
  UpdateDocumentInformation
} from './documents.actions';
import { Parameter } from '@ecosure-suite/shared/utils-helpers';

@Injectable({
  providedIn: 'root'
})
export class DocumentsFacade {
  loaded$ = this.store.pipe(select(documentsQuery.getLoaded));
  allDocuments$ = this.store.pipe(select(documentsQuery.getAllDocuments));
  selectedDocument$ = this.store.pipe(
    select(documentsQuery.getSelectedDocument)
  );

  constructor(private store: Store<DocumentsPartialState>) {}

  loadAllByOwner(owner: Parameter) {
    this.store.dispatch(new LoadOwnerDocuments(owner));
  }

  upload(document: DocumentForm) {
    this.store.dispatch(new SaveDocumentInformation(document));
  }

  editUpload(document: DocumentForm) {
    this.store.dispatch(new UpdateDocumentInformation(document));
  }
}
